import moment from "moment";
import GetHrsTime from "../../utility/GetHrsTime";


export const getStageMessage = ({
  actionType,
  actionByEmpID,
  actionByEmpName,
  createdByEmpID,
  createdByEmpName,
  hostedByEmpID,
  hostedByEmpName,
  userID,
  data,
  details
}) => {

  let msg = "";
  let leftImage = null;
  let rightImage = null;
  let icon = null;
  let showRight = false;
  let showIcon = false;

  const formatTime = (dateStr) => {
    return moment(dateStr).format("hh:mm A , DD MMMM").toUpperCase();
  };

  
  if (actionType == 0) {
    const time = formatTime(data);

    msg += createdByEmpID == userID ? "You" : createdByEmpName;

    leftImage = createdByEmpID;

    if (hostedByEmpID == createdByEmpID) {
      msg += ` scheduled a meeting at ${time}`;
    } else {
      msg += ` scheduled a meeting at ${time} to be hosted by `;
      msg += hostedByEmpID == userID ? "you" : hostedByEmpName;

      rightImage = hostedByEmpID;
      showRight = true;
      showIcon = true;
      icon = "host";
    }
  }

  else if (actionType == 1) {
    leftImage = actionByEmpID;
    msg += hostedByEmpID == userID ? "You" : actionByEmpName;
    msg += " started the meeting";
  }


  else if (actionType == 2) {
    leftImage = actionByEmpID;

    msg += actionByEmpID == userID ? "You" : actionByEmpName;
    msg += " joined the meeting";

    try {
      const d = data.split(",");

      if (d[0] !== actionByEmpID) {
        msg += " via ";
        msg += d[0] == userID ? "you" : d[1];

        rightImage = d[0];
        showRight = true;
      }

      const lateMinutes = parseInt(d[2]);
      if (lateMinutes > 0) {
        msg += `<br/>${lateMinutes} ${lateMinutes > 1 ? "mins" : "min"} late`;
      }
    } catch (e) {}
  }

  else if (actionType == 3) {
    leftImage = hostedByEmpID;
    msg += hostedByEmpID == userID ? "You" : hostedByEmpName;
    msg += " closed the meeting";
  }

 
  else if ([5, 6, 7].includes(actionType)) {
    leftImage = actionByEmpID;
    msg += actionByEmpID == userID ? "You" : actionByEmpName;

    const actions = {
      5: " left the meeting",
      6: " cancelled the meeting",
      7: " updated meeting information"
    };

    msg += actions[actionType];
  }

 
  else if (actionType == 8) {
    leftImage = actionByEmpID;
    msg += actionByEmpID == userID ? "You" : actionByEmpName;
    msg += ` changed meeting location to ${details?.location}`;
  }

 
  else if (actionType == 9) {
    leftImage = actionByEmpID;

    msg += actionByEmpID == userID ? "You" : actionByEmpName;

    try {
      const time = formatTime(data.split(";")[1]);
      msg += ` changed scheduled time to<br/>${time}`;
    } catch (e) {}
  }


  else if (actionType == 11) {
    leftImage = actionByEmpID;

    msg += actionByEmpID == userID ? "You" : actionByEmpName;
    msg += ` changed duration to ${GetHrsTime(details?.duration)}`;
  }


  else if (actionType == 13) {
    leftImage = actionByEmpID;

    msg += actionByEmpID == userID ? "You" : actionByEmpName;
    msg += " created google meet for this meeting";
  }


  else if (actionType == 10) {
    try {
      leftImage = actionByEmpID;

      const parts = data.split(";");
      const previds = parts[0].split(",");
      const prevnames = parts[1].split(",");
      const currIDs = parts[2].split(",");
      const currnames = parts[3].split(",");

      const previous = Object.fromEntries(previds.map((id, i) => [id, prevnames[i]]));
      const current = Object.fromEntries(currIDs.map((id, i) => [id, currnames[i]]));

      let removed = [];
      let added = [];

      Object.keys(previous).forEach(id => {
        if (!current[id]) removed.push(previous[id]);
      });

      Object.keys(current).forEach(id => {
        if (!previous[id]) added.push(current[id]);
      });

      msg += actionByEmpID == userID ? "You" : actionByEmpName;

      if (removed.length) {
        msg += ` removed ${removed.join(", ")}<br/>`;
      }

      if (added.length) {
        msg += `added ${added.join(", ")}`;
      }

    } catch (e) {
      msg = "Old Version Message";
    }
  }

  else if (actionType == 12) {
    try {
      leftImage = actionByEmpID;
      rightImage = hostedByEmpID;
      showRight = true;
      showIcon = true;
      icon = "host";

      msg += actionByEmpID == userID ? "You" : actionByEmpName;
      msg += ` changed the host to ${data.split(",")[1]}`;
    } catch (e) {
      msg = "Old Version Message";
    }
  }

  return {
    message: msg,
    leftImage,
    rightImage,
    icon,
    showRight,
    showIcon
  };
};